export class ConceptInvoicingImportModel {
  counter: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  alterCode2: string | null = null;
  name: string = '';
  cxcConcept: string | null = null;
  conceptInvoicingPriceOfId: number = 0;
  affectsInventory: boolean | null = null;
  promptPayment: boolean | null = null;
  conceptInvoicingType: number = 0;

  constructor(
    counter: number = 0,
    code: number = 0,
    alterCode: string | null = null,
    alterCode2: string | null = null,
    name: string = '',
    cxcConcept: string | null = null,
    conceptInvoicingPriceOfId: number = 0,
    affectsInventory: boolean | null = null,
    promptPayment: boolean | null = null,
    conceptInvoicingType: number = 0
  ) {
    this.counter = counter;
    this.code = code;
    this.alterCode = alterCode;
    this.alterCode2 = alterCode2;
    this.name = name;
    this.cxcConcept = cxcConcept;
    this.conceptInvoicingPriceOfId = conceptInvoicingPriceOfId;
    this.affectsInventory = affectsInventory;
    this.promptPayment = promptPayment;
    this.conceptInvoicingType = conceptInvoicingType;
  }
}
